// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3cXMk","inner":"Footer_inner__3modV","nextIcon":"Footer_nextIcon__i1h8d","innerLeft":"Footer_innerLeft__LvkVY"};